import React from 'react'

import { CopyButton } from '@components/common/CopyButton'
import { Dashboard } from '@components/common/Dashboard/Dashboard'

import { useOverviewContext } from '../../hooks/useOverviewContext'
import { HeaderSkeleton } from './HeaderSkeleton'
import * as S from './styled'

export const Header = () => {
  const overview = useOverviewContext()

  if (
    overview.isLoading ||
    overview.membershipsUrl === null ||
    overview.membershipsStatus === null
  ) {
    return <HeaderSkeleton />
  }

  if (overview.onboarding.active) return null

  return (
    <Dashboard.Section
      name="Memberships overview"
      title={
        overview.membershipsStatus === 'Live' ? (
          <S.Title>
            Your members-only area is available at&nbsp;{' '}
            <S.CopyLinkWrapper>
              <CopyButton
                label={overview.membershipsUrl.label}
                href={overview.membershipsUrl.href}
                copyText={overview.membershipsUrl.href}
                copyLabel="Copy link"
              />
            </S.CopyLinkWrapper>
          </S.Title>
        ) : null
      }
      bottomMargin="large"
    />
  )
}
